import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { ShieldAlert, ArrowLeft } from "lucide-react";

export default function RefundPolicy() {
  const { t } = useApp();
  useEffect(() => {
    document.title = "Refund Policy | AstroFriend";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="mx-auto max-w-2xl px-6 py-14">
      <Link to="/" className="inline-flex items-center gap-2 text-sm text-amber-300/80 hover:text-amber-200 mb-6">
        <ArrowLeft size={16} /> {t.common.back}
      </Link>
      <h1 className="font-serif text-3xl sm:text-4xl font-bold text-amber-50 mb-4" data-testid="policy-title">{t.refund.title}</h1>
      <p className="text-slate-300 mb-6">{t.refund.intro}</p>

      <div className="glass-strong rounded-2xl p-6 border border-amber-500/30 flex gap-4" data-testid="refund-policy-body">
        <ShieldAlert className="text-amber-300 shrink-0 mt-0.5" size={22} />
        <p className="text-lg text-amber-100 font-medium leading-relaxed">{t.refund.body}</p>
      </div>

      <p className="mt-6 text-sm text-slate-400 leading-relaxed">{t.refund.note}</p>
    </div>
  );
}
